import "components/Sorry/sorry.scss";
import { useEffect, useState } from "react";
import { getSorryPage } from "services/get-getSorryPage";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { cartState, overlayState } from "atoms";
import { postClearOrder } from "services/post-clearOrder";
import { ResponseObject, Self } from "atoms/models";
import useResetMultipleStates from "hooks/reset-state";

interface Links {
  self: Self;
  "ec:windowLocation"?: { href: string };
}

const Sorry = () => {
  const [cancelDate, setCancelDate] = useState("");
  const setShowOverlay = useSetRecoilState(overlayState);
  const [cart, setCart] = useRecoilState(cartState);
  const resetState = useResetMultipleStates();
  const navigate = useNavigate();
  useEffect(() => {
    window.scroll(0, 0);
    const fetchSorryPage = async () => {
      const response = await getSorryPage();
      const _links = response["_links"];
      const _embedded = response["_embedded"];
      if (_links["ec:windowLocation"]?.href) {
        navigate(_links["ec:windowLocation"].href);
      } else {
        if (_embedded["ec:cancel-services-date"]) {
          setCancelDate(_embedded["ec:cancel-services-date"]);
        }
        if (_embedded["ec:cart"]) {
          setCart(_embedded["ec:cart"]);
        }
      }
    };
    fetchSorryPage();
  }, [navigate, setCart]);

  const formatDateString = (dateStr: string) => {
    const [year, month, day] = dateStr.split("-");
    return `${month}/${day}/${year}`;
  };

  const handleChangeAddress = async () => {
    setShowOverlay(true);
    const cancelReason = cart.isCurrentCustomer ? "Go to my Comporium button clicked." : "Not my address button clicked.";
    const cartCreated = cart.isCurrentCustomer ? false : true;
    const response: ResponseObject = await postClearOrder(cancelReason, cartCreated);
    if (response.message === "Bad Request") {
      navigate("address-search");
    } else {
      const { _links: links = {} as Links } = response;
      const windowLocationHref = links["ec:windowLocation"]?.href;
      if (windowLocationHref) {
        if (windowLocationHref.includes("shop")) {
          navigate(windowLocationHref);
        } else {
          window.location.href = windowLocationHref;
        }
      }
    }
  };

  return (
    <div className="sorry-container">
      <div className="fw-bold p-3">
        <h5 className="fw-bold mb-3">We’re Sorry to See You Go</h5>
        <p>
          You’ve been a valued subscriber, and we truly appreciate the time you’ve spent with us. While we’re sad to see you leave, we respect your
          decision and hope to serve you again in the future. If there’s anything we can do to improve or support you further, please don’t hesitate
          to let us know.
        </p>
        <p>
          Your service will officially end on&nbsp;
          {cancelDate ? <span className="fst-italic">{formatDateString(cancelDate)}</span> : "your selected cancel date"}. If you have any equipment
          from us, please be sure to return it within 3 days of cancellation to avoid additional charges.
        </p>
        <button
          className="btn btn-lg btn-primary text-dark fw-bold mt-5"
          onClick={() => {
            handleChangeAddress();
            resetState();
          }}
        >
          Back To My Comporium
        </button>
      </div>
    </div>
  );
};

export default Sorry;
